import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { locationReceiptSettingsGetKitchenTicketSettings } from "~/api-refs";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

import { KitchenTicketReceiptSettingsForm } from "../../../../../components/receipts/kitchen-ticket-form";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/receipts/kitchen-ticket"
)({
  component: KitchenTicketReceiptSettingsPage,
});

function KitchenTicketReceiptSettingsPage() {
  const { id } = Route.useParams();

  const { data: settings, isPending } = useQuery(
    convexQuery(locationReceiptSettingsGetKitchenTicketSettings, {
      locationId: toConvexTableId("locations", id),
    })
  );

  if (isPending) {
    return <LoadingPanel message="Loading settings..." />;
  }

  return (
    <KitchenTicketReceiptSettingsForm
      locationId={toConvexTableId("locations", id)}
      settings={settings ?? null}
    />
  );
}
